import React, { useState, useEffect } from 'react';
import { PublicBooking } from './pages/PublicBooking';
import { PublicTracking } from './pages/PublicTracking';
import { AdminDashboard } from './pages/AdminDashboard';
import { Login } from './pages/Login';
import { Layout } from './components/Layout';
import { isAuthenticated } from './services/authService';

function App() {
  const [route, setRoute] = useState(window.location.hash || '#/');
  const [isLoggedIn, setIsLoggedIn] = useState(isAuthenticated());
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      setIsLoggedIn(false);
      setSessionExpired(true);
    };
    window.addEventListener('auth-session-expired', handleSessionExpired);
    return () => window.removeEventListener('auth-session-expired', handleSessionExpired);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(window.location.hash || '#/');
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setSessionExpired(false);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    window.location.hash = '#/';
  };

  // Simple Hash Router Logic
  const renderPage = () => {
    if (route === '#/admin') {
      if (isLoggedIn) {
        return <AdminDashboard onLogout={handleLogout} />;
      } else {
        return (
          <Layout>
            {sessionExpired && <p role="status" className="max-w-md mx-auto mt-6 rounded-lg bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-900">Sua sessão expirou. Entre novamente para acessar a agenda.</p>}
            <Login onLoginSuccess={handleLoginSuccess} />
          </Layout>
        );
      }
    }

    if (route === '#/tracking') {
      return <PublicTracking />;
    }

    if (route === '#/embed/tracking') {
      return <PublicTracking isEmbed />;
    }

    if (route === '#/embed') {
      return <PublicBooking isEmbed />;
    }

    // Default to booking
    return <PublicBooking />;
  };

  return (
    <>
      {renderPage()}
    </>
  );
}

export default App;
